import {
  RequirementWorkflowType,
  WorkerRequirementDomain,
  WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetWorkplace } from "@src/appV2/Facilities/api/useGetWorkplace";

import { useGetRequirementsForWorkplace } from "./wrappers/useGetRequirementsForWorkplace";

export function useHasTen99PolicyCoverage({
  shiftQualification,
  workplaceId,
}: {
  shiftQualification: string;
  workplaceId: string | undefined;
}): boolean {
  const { data: workplace } = useGetWorkplace({ workplaceId }, { enabled: isDefined(workplaceId) });
  const ten99PolicyEntityId = workplace?.data?.attributes?.ten99PolicyEntityId;

  const { data: workerRequirements } = useGetRequirementsForWorkplace(
    {
      qualifications: [shiftQualification],
      domain: WorkerRequirementDomain.FLEX,
      workplaceId: workplaceId ?? "",
    },
    {
      enabled:
        isDefined(shiftQualification) && isDefined(workplaceId) && isDefined(ten99PolicyEntityId),
    }
  );
  return isDefined(
    workerRequirements?.find(
      (workerRequirement) =>
        workerRequirement.requirement?.attributes.requirementWorkflowType ===
          RequirementWorkflowType.TEN99_POLICY_COVERAGE &&
        workerRequirement.status === WorkerRequirementStatus.APPROVED
    )
  );
}
